import { call, put, select } from 'redux-saga/effects';

import userSelectors from '@elab/core/store/user/selectors';
import cartSelectors from '@elab/core/store/cart/selectors';
import RtsAPI from '@elab/components/connected/real-time-stock/redux/api';
import logger from '@elab/core/utils/logger';
import constants from '@elab/core/utils/constants';

import actions from '../../components/connected/DeliveryModes/redux/actions';
import selectors from '../../components/connected/DeliveryModes/redux/selectors';

export function* checkRts(cartData) {
    let data = cartData;
    const checkRts = yield select(selectors.getCheckRts);

    if (!cartData) {
        data = yield select(cartSelectors.getData);
    }

    try {
        if (checkRts && data.deliveryMode) {
            if (data.deliveryMode.type.toLowerCase() === constants.ccDeliveryType) {
                const userId = yield select(userSelectors.getUserId);
                const cartId = yield select(cartSelectors.getCartId);

                const rts = yield call(
                    RtsAPI.getCartProductsStock,
                    userId,
                    cartId,
                    { query: '' },
                    true,
                );

                const rtsAvailable = !rts.hasOwnProperty('errors');
                yield put(actions.setRtsAvailable(rtsAvailable));
                yield put(actions.setShowRtsUnreachableMsg(!rtsAvailable));

                if (!rtsAvailable) {
                    yield put(actions.setDeliveryBlocked(true));
                }
            } else {
                yield put(actions.setShowRtsUnreachableMsg(false));
            }
        }
    } catch (e) {
        yield call(logger.error, e);
    }
}
